const clean = value => (typeof value === 'string' ? value.trim() : '');

/**
 * Converts a Loqate Retrieve item to a neutral address any form can map onto its own fields:
 * { company, line1, line2, city, postcode, countryIso2, provinceCode, provinceName }.
 * `line2` is Loqate's Line2 to Line5, empty lines dropped, joined with ", ".
 */
const normaliseAddress = (item = {}) => ({
  company: clean(item.Company),
  line1: clean(item.Line1),
  line2: [item.Line2, item.Line3, item.Line4, item.Line5].map(clean).filter(Boolean).join(', '),
  city: clean(item.City),
  postcode: clean(item.PostalCode),
  countryIso2: clean(item.CountryIso2).toUpperCase(),
  provinceCode: clean(item.ProvinceCode),
  provinceName: clean(item.ProvinceName)
});

export default normaliseAddress;
